import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const createReservationAPI = async ({
    authToken,
    subsidiaryId,
    customerId,
    vehicleId,
    startDate,
    endDate,
    expectedKm = 0,
    options = []
}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);

    const URL = `${BASE_URL}/${requestSubsidiaryId}/client/reservations`
    const METHOD = "POST"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
    }

    const payload = {
        "planned_start_date": startDate,
        "planned_end_date": endDate,
        "customer": customerId,
        "vehicle": vehicleId,
        "expected_kilometers": Number(expectedKm) || 0,
        "purchase_order_number": "",
        "cost_center": "",
        "cost_unit": "",
        "reservation_source": "web"
    }

    const normalizedOptions = Array.isArray(options)
        ? options.map((value) => Number(value)).filter((value) => Number.isFinite(value))
        : []

    if (normalizedOptions.length > 0) {
        payload.options = normalizedOptions
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify(payload)
    })

    if (!response.ok) {
        // Keep the API error (e.g. reservation_check.rdw_rejected) so the page can show the right message.
        const error = new Error(`HTTP error: ${response.status}`)
        error.status = response.status
        error.apiError = await response.json().then((body) => body?.error || null).catch(() => null)
        throw error
    }

    return await response.json()
}

export {createReservationAPI}
